.productLink {
  color: var(--color-regular-links);
}
